export default __webpack_public_path__ + "static/title-82a5222fe2c22b31da122157e60a8423.webp";